import {withComponent} from '../../hoc/withComponent';
import {TableBase} from './TableBase';

export const withTable = withComponent(TableBase);
